module.exports = __webpack_public_path__ + "static/media/customers.d164b368.jpg";